// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2aIdc","label":"Category_label__1Vbat","content":"Category_content__3pLjS","header":"Category_header__3a30-","location":"Category_location__1-qFv"};